import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingComponent } from '../../shared/components/loading/loading.component';

@Component({
  selector: 'app-payment-callback',
  standalone: true,
  imports: [CommonModule, LoadingComponent],
  template: `
    <div class="payment-callback-container" style="display: flex; align-items: center; justify-content: center; min-height: 100vh; background: #f8f9fa;">
      <div class="text-center">
        <div *ngIf="isProcessing" class="mb-30">
          <app-loading [size]="'large'" [message]="'Ödeme işleniyor...'"></app-loading>
        </div>
        
        <div *ngIf="isSuccess && !isProcessing" class="mb-30">
          <div class="icon-success mb-20" style="font-size: 64px; color: #4CAF50;">
            <i class="icon-check-circle"></i>
          </div>
          <h3 class="text-24 fw-600 text-green-1">Ödeme Başarılı!</h3>
          <p class="text-16 text-light-1 mt-15">Rezervasyonunuz oluşturuluyor...</p>
        </div>
        
        <div *ngIf="isFailed && !isProcessing" class="mb-30">
          <div class="mb-20" style="font-size: 64px; color: #d97706;">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" style="display:inline-block;"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          </div>
          <h3 class="text-24 fw-600" style="color: #92400e;">Ödeme Tamamlanamadı</h3>
          <p class="text-16 text-light-1 mt-15">{{ errorMessage }}</p>
          <button class="btn btn-primary mt-20" (click)="goBackToPayment()">Ödeme Sayfasına Dön</button>
        </div>
      </div>
    </div>
  `,
  styles: [``]
})
export class PaymentCallbackComponent implements OnInit {
  isProcessing = true;
  isSuccess = false;
  isFailed = false;
  errorMessage = '';
  
  conversationId = '';
  paymentId = '';
  token = '';
  status = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    // URL parametrelerinden ödeme bilgilerini al
    this.route.queryParams.subscribe(params => {
      this.conversationId = params['conversationId'] || '';
      this.paymentId = params['paymentId'] || '';
      this.token = params['token'] || '';
      this.status = params['status'] || '';
      
      // Ödeme durumunu kontrol et
      this.processPaymentCallback();
    });
  }

  private processPaymentCallback(): void {
    setTimeout(() => {
      this.isProcessing = false;
      
      if (this.status === 'success') {
        this.isSuccess = true;
        
        // Parent window'a mesaj gönder
        if (window.opener) {
          window.opener.postMessage({
            type: 'PAYMENT_SUCCESS',
            conversationId: this.conversationId,
            paymentId: this.paymentId
          }, '*');
          
          // Pencereyi kapat
          setTimeout(() => {
            window.close();
          }, 2000);
        } else {
          // Opener yoksa, doğrudan rezervasyon onay sayfasına yönlendir
          setTimeout(() => {
            this.router.navigate(['/odeme'], {
              queryParams: {
                paymentSuccess: 'true',
                conversationId: this.conversationId,
                paymentId: this.paymentId
              }
            });
          }, 2000);
        }
      } else {
        this.isFailed = true;
        this.errorMessage = 'Ödeme işlemi başarısız oldu. Lütfen tekrar deneyiniz.';
        
        // Parent window'a hata mesajı gönder
        if (window.opener) {
          window.opener.postMessage({
            type: 'PAYMENT_FAILED',
            message: this.errorMessage,
            conversationId: this.conversationId
          }, '*');
        }
      }
    }, 1500); // 1.5 saniye bekle (kullanıcı deneyimi için)
  }

  goBackToPayment(): void {
    if (window.opener) {
      window.close();
    } else {
      this.router.navigate(['/odeme']);
    }
  }
}












